<script>
import BasePopup from '../../BasePopup.vue';
import BaseDatepicker from '../../BaseDatepicker.vue';

export default {
  name: 'TaskViewDatePopup',
  components: { BaseDatepicker, BasePopup },
  props: {
    subTitle: String,
  },
  data() {
    return {
      newDate: null,
    };
  },
  methods: {
    async submit(boolean) {
      if (boolean) {
        this.$emit('submit', this.newDate);
      } else {
        this.$emit('close');
      }
    },
  },
};
</script>

<template lang="pug">
BasePopup(@close="submit(false)" :zIndex="9000")
  .dates
    .date-header Изменить срок
    .options
      .date-container
        .date-regular {{ subTitle }}
        BaseDatepicker(v-model="newDate")
    .buttons
      Btn(@click="submit(true)" transparent round narrow) Применить
      Btn(@click="newDate = null" transparent round narrow) Сбросить
</template>

<style scoped lang="scss">
.date-regular {
  color: rgba(30, 49, 71, 1);
  font-family: Geometria, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.date-header {
   display: flex;
   color: rgba(35, 34, 38, 1);
   font-family: Geometria, sans-serif;
   font-size: 24px;
   font-style: normal;
   font-weight: 500;
   line-height: 24px;
}

.options {
  padding-top: 41px;
  padding-bottom: 35px;
  display: flex;
  gap: 50px;
}

.date-container {
  display: flex;
  gap: 15px;
  align-items: center;
}

.buttons {
  display: flex;
  gap: 30px;
}
</style>
